import { responsive, spacing, ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

export const dataGrid: ThemeUICSSObject = {
  variant: 'grids.form',

  display: responsive({ 0: 'flex', 2: 'grid' }),
  flexDirection: 'column',
  gap: spacing(6),

  alignItems: 'start',
  gridAutoRows: 'none',
  gridTemplateColumns: responsive({
    0: 'repeat(1, 1fr)',

    2: 'repeat(3, 1fr)',

    4: 'repeat(3, 1fr)',
    5: 'repeat(5, 1fr)',
  }),

  '& label': {
    display: 'block',

    '.elementValue': {
      fontWeight: 'normal',

      '.errorContainer': {
        flexDirection: 'column',
        alignItems: 'center',

        div: {
          position: 'relative',
        },
      },
    },

    '&.identifier, &.calendar': {
      gridColumn: responsive({ 0: 'span 2', 5: 'span 3', 6: 'span 2' }),

      div: {
        display: 'flex',
        gap: spacing(1),
        alignItems: 'center',

        '.separator': {
          alignSelf: 'center',
        },

        input: {
          minWidth: '60px',
        },

        '.body': {
          width: '100%',
        },

        '.identifier__body': {
          flexShrink: 0,
        },
      },
    },

    'strong + div': {
      wordBreak: 'break-all',
    },
  },
};

export const entityAndProcessData: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(7),

  '.collapsiblePanel__label': {
    mb: spacing(3),
    h3: {
      m: spacing(0),
      fontSize: 18,
    },
  },

  '.collapsiblePanel__content': {
    '&:not([aria-hidden="true"])': {
      border: '1px solid',
      borderColor: 'palette.border.article',
    },

    '& > div > *:not(.noPadding)': {
      p: spacing(7),
    },
  },

  '.dataGrid': dataGrid,

  '.dropzone': {
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
  },
};

const entityData: ThemeUICSSObject = {
  ...entityAndProcessData,

  '& h2': {
    '&.visibilitiesTitle': {
      display: 'flex',
      justifyContent: 'start',
      gap: spacing(3),
    },
  },

  '.imageSelector': {
    button: {
      border: 'none',
      cursor: 'pointer',
      p: spacing(0),
      width: '75px',
      img: {
        width: '100%',
      },
    },
  },

  '.EntityDataDocuments': {
    '.entityData__actions': {
      p: spacing(3),
    },
  },

  '.categories__tree__label': {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(3),

    '& > div': {
      display: 'flex',
      py: spacing(2),
    },
  },
  /* PREPEND HERE */
};

export default entityData;
